"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _store = require("./store");

var LOG_KEY = 'showLog';

function log() {
  if (!console || !console.log) return;
  var showLog = (0, _store.getLocalData)(LOG_KEY);
  if (!showLog) return;
  console.log.apply(null, arguments);
}

var _default = log;
exports["default"] = _default;